import React from 'react'

export type DivProps = React.DetailedHTMLProps<React.HTMLProps<HTMLDivElement>, HTMLDivElement>
/** @deprecated */
export function Div(props: DivProps) {
  return <div {...props} />
}
